module.exports = __webpack_public_path__ + "static/media/16UNODC38.780f7148.jpg";